/*
 * site.js - the shared enhancement module, extracted once from the inline <script type="module">
 * that every approved static page repeated (spec 4). Behaviour is unchanged, including the
 * accordion that rebuilds the mobile panel's groups.
 *
 * Vanilla JS only - no jQuery, no inline handlers (UI Development Framework v1.2.0).
 */

// --- Desktop dropdowns: click to open, Escape + outside click to close (N2) ---
const dropdowns = [...document.querySelectorAll('[data-dropdown]')];
const closeAll = (except) => dropdowns.forEach(d => {
  if (d === except) return;
  d.querySelector('.nav-toggle').setAttribute('aria-expanded', 'false');
  d.querySelector('.submenu').classList.remove('open');
});
dropdowns.forEach(d => {
  const btn = d.querySelector('.nav-toggle');
  const menu = d.querySelector('.submenu');
  btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') === 'true';
    closeAll(d);
    btn.setAttribute('aria-expanded', String(!open));
    menu.classList.toggle('open', !open);
  });
});
document.addEventListener('click', (e) => { if (!e.target.closest('[data-dropdown]')) closeAll(); });
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeAll();
    const mp = document.getElementById('mobile-panel');
    if (mp.classList.contains('open')) { mp.classList.remove('open'); menuBtn.setAttribute('aria-expanded', 'false'); }
  }
});

// --- Mobile menu disclosure ---
const menuBtn = document.getElementById('menu-btn');
const panel = document.getElementById('mobile-panel');
menuBtn.addEventListener('click', () => {
  const open = menuBtn.getAttribute('aria-expanded') === 'true';
  menuBtn.setAttribute('aria-expanded', String(!open));
  menuBtn.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
  panel.classList.toggle('open', !open);
});

// --- Mobile nav accordion: collapse groups (long Features list) ---
(function(){
  const mpUl = panel.querySelector('ul');
  if(!mpUl) return;
  const items=[...mpUl.children];
  const frag=document.createDocumentFragment();
  let currentList=null;
  items.forEach(li=>{
    if(li.classList.contains('grp')){
      const wrap=document.createElement('li'); wrap.className='m-group';
      const btn=document.createElement('button'); btn.type='button'; btn.className='m-grp-toggle'; btn.setAttribute('aria-expanded','false');
      btn.innerHTML='<span>'+li.textContent.trim()+'</span><span class="m-caret" aria-hidden="true">\u25be</span>';
      const sub=document.createElement('ul'); sub.className='m-sub';
      btn.addEventListener('click',()=>{const o=btn.getAttribute('aria-expanded')==='true'; btn.setAttribute('aria-expanded',String(!o)); sub.classList.toggle('open',!o);});
      wrap.appendChild(btn); wrap.appendChild(sub); frag.appendChild(wrap); currentList=sub;
    } else if(currentList && li.querySelector('a') && !li.querySelector('a.btn')){
      currentList.appendChild(li);
    } else { currentList=null; frag.appendChild(li); }
  });
  mpUl.innerHTML=''; mpUl.appendChild(frag);
})();
  
